<h1 mat-dialog-title>Hinweis zu Ihrem Zugang</h1>
<mat-dialog-content>
  <div class="icon-bar">
    <mat-icon>access_time</mat-icon>
  </div>

  <p>
    {{data.message}}
  </p>

</mat-dialog-content>
<div mat-dialog-actions>
  <button mat-button (click)="close()" cdkFocusInitial>Schließen</button>
</div>
